import { Box, Typography } from '@mui/material';
import { TFieldsOperations } from '@componentsroot/Form/FormGenerator/utils';
import FormSelect from '@componentsroot/Form/FormSelect';
import { TCountryCode } from '@verifime/utils';
import Address, { TAddressProps } from '@componentsroot/Form/Address';
import { TFormFieldsAndRulesV1ForAddressOnly as TFormFieldsAndRules } from '@componentsroot/Form/FormGenerator/v1ForAddressOnly';

export type TAddressWithCountrySelectProps = {
  formValidations: TFormFieldsAndRules;
  onCountryChange?: (newCountryCode: TCountryCode) => void;
  defaultValues: Record<string, any>;
  addressInputLabel?: string;
  addressInputPlaceholder?: string;
  inputsFieldsOperations?: TFieldsOperations;
} & Omit<TAddressProps, 'addressFieldsAndRules'>;

export default function AddressWithCountrySelect({
  formValidations,
  countryCode,
  control,
  errors,
  onCountryChange,
  onPlaceSelected,
  trigger,
  setValue,
  label,
  addressInputLabel,
  addressInputPlaceholder,
  ...props
}: TAddressWithCountrySelectProps) {
  // We'd like to show country separately above other fields
  const countryField = formValidations.countryCode;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }} key={countryCode}>
      <Typography sx={{ opacity: '.8' }}>{label ?? 'Address'}</Typography>

      <FormSelect
        required
        name={countryField.fieldName}
        label={countryField.label}
        control={control}
        defaultValue={countryCode}
        onOptionChange={(e) => {
          onCountryChange?.(e.target.value as TCountryCode);
        }}
      >
        {countryField.renderItems()}
      </FormSelect>
      <Address
        countryCode={countryCode}
        addressFieldsAndRules={formValidations}
        control={control}
        errors={errors}
        trigger={trigger}
        setValue={setValue}
        onPlaceSelected={onPlaceSelected}
        label={addressInputLabel}
        placeholder={addressInputPlaceholder}
        {...props}
      />
    </Box>
  );
}
